module.exports = __webpack_public_path__ + "i18n/de.3edbf06a1c75361dba2711e73360d6a2.json";